module.exports = __webpack_public_path__ + "static/media/carte-bulgarie.6f834617.svg";